import React from 'react';
import PropTypes from 'prop-types';

import {VehicleTile} from "./vehicle-tile";
import {BaseVehicleGrid} from './base-vehicle-grid';


export class VehicleGrid extends React.PureComponent {
    static propTypes = {
        numCols: PropTypes.shape({
            xs: PropTypes.number.isRequired,
            md: PropTypes.number.isRequired,
            lg: PropTypes.number.isRequired,
        }).isRequired,
        maxRows: PropTypes.shape({
            xs: PropTypes.number.isRequired,
            md: PropTypes.number.isRequired,
            lg: PropTypes.number.isRequired,
        }).isRequired,

        // controlled component props
        items: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                slug: PropTypes.string,
                starting_price: PropTypes.number.isRequired,
                primary_image: PropTypes.string.isRequired,
                alt: PropTypes.string,
            })
        ),
        loadItems: PropTypes.func,
    };

    static defaultProps = {
        numCols: {
            xs: 2,
            md: 2,
            lg: 3,
        },
        maxRows: {
            xs: 1,
            md: 1,
            lg: 1,
        }
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            items: props.items,
        };
    }

    componentDidMount() {
        if (this.props.loadItems) {
            this.props.loadItems().then(items => this.setState({items}));
        }
    }

    componentWillReceiveProps(props) {
        if (props.items !== this.props.items) {
            this.setState({items: props.items});
        }
    }

    render() {
        const {items} = this.state;
        const {numCols, maxRows} = this.props;

        if (!items || !items.length) {
            return (
                <div className="spinner-border spark-text-secondary d-block my-5 mx-auto">
                    <span className="sr-only">Loading...</span>
                </div>
            );
        }

        return (
            <BaseVehicleGrid numItems={items.length} numCols={numCols} maxRows={maxRows}>
                {this.state.items.map(item => (
                    <VehicleTile key={item.id} {...item}/>
                ))}
            </BaseVehicleGrid>
        );
    }
}


